import { useEffect, useState } from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { useAdmin } from '@/hooks/useAdmin';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminBugReports() {
  const { authFetch } = useAdmin();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    authFetch(`${API}/admin/bug-reports`)
      .then(r => r.json())
      .then(d => setRows(d.reports || d.items || (Array.isArray(d) ? d : [])))
      .finally(() => setLoading(false));
  }, [authFetch]);

  const filtered = rows.filter(r => filter === 'all' || (r.status || 'open') === filter);

  return (
    <div className="p-4 md:p-6" data-testid="admin-bug-reports">
      <div className="flex items-center gap-3 mb-6">
        <AlertTriangle className="text-red-500" size={24} />
        <div>
          <h1 className="text-2xl font-bold">Prijavljeni bugovi</h1>
          <p className="text-sm text-zinc-400">Prijave korisnika s javnih stranica.</p>
        </div>
      </div>
      <div className="flex gap-2 mb-4">
        {['all', 'open', 'resolved'].map(f => (
          <button key={f} onClick={() => setFilter(f)} data-testid={`bug-filter-${f}`}
                  className={`px-3 py-1.5 rounded text-xs font-bold ${filter === f ? 'bg-red-600 text-white' : 'bg-zinc-800 text-zinc-300'}`}>
            {f === 'all' ? 'Svi' : f === 'open' ? 'Otvoreni' : 'Riješeni'}
          </button>
        ))}
      </div>
      {loading ? <Loader2 className="animate-spin text-zinc-500" /> : (
        <div className="space-y-3">
          {filtered.map((r, i) => (
            <div key={r.id || i} data-testid={`bug-${r.id}`}
                 className="p-4 rounded-lg border border-zinc-800 bg-zinc-900">
              <div className="flex justify-between items-start gap-3">
                <div className="flex-1 min-w-0">
                  <div className="text-xs text-zinc-500 mb-1">
                    {(r.created_at || '').slice(0, 16).replace('T', ' ')}
                    {r.email && <span className="ml-2 text-red-400">{r.email}</span>}
                    {r.page_url && <span className="ml-2"><a href={r.page_url} className="text-zinc-400 hover:underline">{r.page_url}</a></span>}
                  </div>
                  <p className="text-sm text-zinc-100 whitespace-pre-wrap">{r.description || r.message || r.body || ''}</p>
                  {r.user_agent && <div className="mt-2 text-[10px] text-zinc-600 truncate">UA: {r.user_agent}</div>}
                </div>
                <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded ${(r.status || 'open') === 'resolved' ? 'bg-emerald-700/40 text-emerald-300' : 'bg-amber-700/40 text-amber-300'}`}>
                  {r.status || 'open'}
                </span>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <div className="text-center py-8 text-zinc-500">Nema prijava.</div>}
        </div>
      )}
    </div>
  );
}
